<div class="filters flex flex-wrap gap-2" [formGroup]="form">
  <ng-content select="[bulkEditBlock]" />

  <div class="w-full max-w-sm">
    <div class="mb-1 h-4"></div>
    <aux-input
      class="w-full"
      placeholder="Search"
      formControlName="search"
      icon="Search"
      iconPosition="left"
      hotKey="/"
    />
  </div>
  <div>
    <span class="mb-1 block text-xs">Vendor Contract:</span>
    <ng-select
      class="big-dropdown tabular-nums"
      style="width: 350px"
      placeholder="All"
      formControlName="vendors"
      bindValue="value"
      [multiple]="true"
      [searchable]="true"
      [items]="invoiceService.vendorOptions"
    >
      <ng-template let-item="item" ng-option-tmp>
        <div
          class="block truncate"
          #text
          [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label : ''"
          [auxTooltipPositions]="optionTooltipPositions"
        >
          {{ item.label }}
        </div>
      </ng-template>
      <ng-template let-items="items" let-clear="clear" ng-multi-label-tmp>
        @if (items.length === 1) {
          <div class="ng-value">
            @for (item of castItemsToOptions(items) | slice: 0 : 1; track item.label) {
              <div class="flex">
                <span class="ng-value-icon left" aria-hidden="true" (click)="clear(item)">×</span>
                <span
                  class="ng-value-label max-w-[200px] overflow-hidden text-ellipsis"
                  #text
                  [auxTooltip]="text.offsetWidth < text.scrollWidth ? item.label : ''"
                  [auxTooltipPositions]="optionTooltipPositions"
                >
                  {{ item.label }}
                </span>
              </div>
            }
          </div>
        } @else if (items.length > 1) {
          <div class="ng-value">
            <span class="ng-value-label">{{ items.length }} Selected</span>
          </div>
        }
      </ng-template>
    </ng-select>
  </div>
  <div>
    <span class="mb-1 block text-xs">Invoice Date:</span>
    <aux-input
      placeholder="YYYY-MM-DD"
      formControlName="invoiceDate"
      class="w-36"
      [type]="'date'"
    />
  </div>
  <div>
    <span class="mb-1 block text-xs">Posting Period:</span>
    <ng-select
      class="w-60 tabular-nums"
      placeholder="All Months"
      formControlName="accrualPeriod"
      bindValue="value"
      [multiple]="true"
      [searchable]="true"
      [items]="invoiceService.accrualPeriodOptions"
    >
      <ng-template let-items="items" let-clear="clear" ng-multi-label-tmp>
        @if (items.length === 1) {
          <div class="ng-value">
            @for (item of castItemsToOptions(items) | slice: 0 : 1; track item.label) {
              <div class="flex">
                <span class="ng-value-icon left" aria-hidden="true" (click)="clear(item)">×</span>
                <span class="ng-value-label overflow-hidden text-ellipsis">
                  {{ item.label }}
                </span>
              </div>
            }
          </div>
        } @else if (items.length > 1) {
          <div class="ng-value">
            <span class="ng-value-label">{{ items.length }} Selected</span>
          </div>
        }
      </ng-template>
    </ng-select>
  </div>
  @if (optionalFilters().is_deposit) {
    <div>
      <aux-multi-select-dropdown
        class="block w-32"
        [prefix]="editMode() ? '' : 'X'"
        placeholder="All"
        label="Deposit"
        [items]="depositItems"
        [formControlName]="'is_deposit'"
        [bindLabel]="'label'"
        [prefixClick]="onRemoveOptionalFilter('is_deposit')"
        [bindValue]="'value'"
        [multiple]="false"
      />
    </div>
  }
  @if (optionalFilters().has_prepaid) {
    <div>
      <aux-multi-select-dropdown
        class="block w-32"
        [prefix]="editMode() ? '' : 'X'"
        placeholder="All"
        label="Prepaid Impact"
        [items]="prepaidItems"
        [formControlName]="'has_prepaid'"
        [bindLabel]="'label'"
        [prefixClick]="onRemoveOptionalFilter('has_prepaid')"
        [bindValue]="'value'"
        [multiple]="false"
      />
    </div>
  }
  @if (optionalFilters().does_invoice_mappings_match_total) {
    <div>
      <aux-multi-select-dropdown
        class="block w-32"
        [prefix]="editMode() ? '' : 'X'"
        placeholder="All"
        label="Mapped to Activities"
        [items]="mappedToActivitiesItems"
        [formControlName]="'does_invoice_mappings_match_total'"
        [bindLabel]="'label'"
        [prefixClick]="onRemoveOptionalFilter('does_invoice_mappings_match_total')"
        [bindValue]="'value'"
        [multiple]="false"
      />
    </div>
  }
  @if (optionalFilters().services_period) {
    <div>
      <aux-multi-select-dropdown
        class="block w-60"
        [prefix]="editMode() ? '' : 'X'"
        placeholder="All"
        label="Service Period"
        [items]="invoiceService.servicePeriodOptions"
        [formControlName]="'services_period'"
        [bindLabel]="'label'"
        [prefixClick]="onRemoveOptionalFilter('services_period')"
        [bindValue]="'value'"
        [multiple]="true"
        [attr.data-pendo-id]="'pendo-service-period-dropdown'"
      />
    </div>
  }

  @if (optionalFilters().purchase_order) {
    <div>
      <aux-multi-select-dropdown
        class="block w-60"
        [prefix]="editMode() ? '' : 'X'"
        placeholder="All"
        label="PO #"
        [items]="invoiceService.purchaseOrderOptions"
        [formControlName]="'purchase_order'"
        [bindLabel]="'label'"
        [prefixClick]="onRemoveOptionalFilter('purchase_order')"
        [bindValue]="'value'"
        [multiple]="true"
        [optionTooltipPositions]="optionTooltipPositions"
        [attr.data-pendo-id]="'pendo-purchase_order-dropdown'"
      />
    </div>
  }

  @if (showAddFilter()) {
    <div class="flex flex-col">
      <div class="mb-1 h-4"></div>
      <aux-button
        class="block flex-1"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        variant="hyperlink"
        [disabled]="form.disabled"
        (auxClickOutside)="isAddFiltersOpen.set(false)"
        (clickEmit)="isAddFiltersOpen.set(true)"
        label="+ Add Filter"
      />
    </div>

    <ng-template
      cdkConnectedOverlay
      class="border-solid border-aux-gray-dark-100"
      [cdkConnectedOverlayOrigin]="trigger"
      [cdkConnectedOverlayOpen]="isAddFiltersOpen()"
    >
      <ul
        tabindex="-1"
        class="mt-2 w-56 overflow-auto rounded border border-aux-gray-dark bg-white text-base"
      >
        @if (!optionalFilters().is_deposit && depositFilterFF()) {
          <li
            class="relative flex cursor-pointer select-none flex-col p-2.5 text-gray-900 hover:bg-aux-gray-light"
            (click)="onAddOptionalFilter('is_deposit')"
          >
            <p class="font-inter">Deposit</p>
          </li>
        }
        @if (!optionalFilters().has_prepaid && prepaidFilterFF()) {
          <li
            class="relative flex cursor-pointer select-none flex-col p-2.5 text-gray-900 hover:bg-aux-gray-light"
            (click)="onAddOptionalFilter('has_prepaid')"
          >
            <p class="font-inter">Prepaid</p>
          </li>
        }
        @if (!optionalFilters().does_invoice_mappings_match_total) {
          <li
            class="relative flex cursor-pointer select-none flex-col p-2.5 text-gray-900 hover:bg-aux-gray-light"
            (click)="onAddOptionalFilter('does_invoice_mappings_match_total')"
          >
            <p class="font-inter">Mapped to Activities</p>
          </li>
        }
        @if (!optionalFilters().services_period) {
          <li
            class="relative flex cursor-pointer select-none flex-col p-2.5 text-gray-900 hover:bg-aux-gray-light"
            (click)="onAddOptionalFilter('services_period')"
          >
            <p class="font-inter">Service Period</p>
          </li>
        }
        @if (!optionalFilters().purchase_order && prepaidFilterFF()) {
          <li
            class="relative flex cursor-pointer select-none flex-col p-2.5 text-gray-900 hover:bg-aux-gray-light"
            (click)="onAddOptionalFilter('purchase_order')"
          >
            <p class="font-inter">PO #</p>
          </li>
        }
      </ul>
    </ng-template>
  }
  <div class="flex flex-col">
    <div class="mb-1 h-4"></div>
    <aux-button
      class="block flex-1"
      variant="hyperlink"
      [disabled]="form.disabled"
      (clickEmit)="resetAllFilters()"
      label="Clear All"
    />
  </div>

  <ng-content select="[togglesBlock]" />

  <ng-content select="[saveBlock]" />
</div>
